import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import AdminLayout from "../../../components/AdminLayout";
import { Cabecalho, Pagina } from "../../../components/AdminLayout/Pagina";
import Esqueleto from "../../../components/Esqueleto";
import { mensagemDeErro, respostaOk } from "../../../../utils/resposta";
import { inicialDoNovoBanner } from "../../../../utils/pedidoBanner";
import Migalhas from "./Migalhas";
import { FormApoiador, FormBanner, FormBioma, FormEspecie } from "./Formularios";
import { FormPagina } from "./styled";
import { caminhoLista, RECURSOS } from "./recursos";

const FORMULARIOS = {
  biomas: FormBioma,
  especies: FormEspecie,
  banners: FormBanner,
  apoiadores: FormApoiador,
};

/**
 * Página de criar (/admin/conteudo/:recurso/novo) ou editar
 * (/admin/conteudo/:recurso/:id/editar) um item. Só os campos: não há mais o
 * passo "pesquise o item a editar" dos modais antigos; o item vem do endereço.
 */
export default function Form() {
  const { recurso, id } = useParams();
  const cfg = RECURSOS[recurso];
  const navigate = useNavigate();
  const editando = Boolean(id);
  const [params] = useSearchParams();

  const [item, setItem] = useState(() => {
    if (editando) return null;
    return recurso === "banners" ? inicialDoNovoBanner(params) : {};
  });

  // Editar: carrega o item pelo id. Se não existir mais (outro administrador
  // excluiu, link velho), volta para a lista com a explicação.
  useEffect(() => {
    if (!cfg || !editando) return undefined;
    let vivo = true;
    cfg.model.findById(id).then((r) => {
      if (!vivo) return;
      if (respostaOk(r)) { setItem(r.data); return; }
      navigate(caminhoLista(recurso), {
        replace: true,
        state: { aviso: { erro: true, texto: `Não foi possível abrir este ${cfg.singular}: ${mensagemDeErro(r)}` } },
      });
    });
    return () => { vivo = false; };
  }, [cfg, editando, id, recurso, navigate]);

  if (!cfg) return <Navigate to="/admin/conteudo" replace />;

  const Campos = FORMULARIOS[recurso];
  const rotuloPagina = editando ? cfg.editar : cfg.novo;

  return (
    <AdminLayout>
      <Pagina>
        <Migalhas itens={[
          { rotulo: "Conteúdo", para: "/admin/conteudo" },
          { rotulo: cfg.titulo, para: caminhoLista(recurso) },
          { rotulo: rotuloPagina },
        ]} />
        <Cabecalho titulo={rotuloPagina} descricao={editando ? undefined : cfg.descricao} />

        <FormPagina>
          {item === null
            ? <Esqueleto variante="texto" quantidade={5} rotulo="Carregando o item" />
            : <Campos
              key={item.id || "novo"} inicial={item} cancelarPara={caminhoLista(recurso)}
              aoSalvar={(avisoEspecial) => navigate(caminhoLista(recurso), { state: { aviso: avisoEspecial || { texto: cfg.salvo } } })}
            />}
        </FormPagina>
      </Pagina>
    </AdminLayout>
  );
}
